import { isProduction } from '../helpers'

const LABEL = 'Timing'

/**
 * Wraps an async function to log its execution duration in non-production environments.
 * No-op in production — returns the original function unchanged.
 */
export function withTiming<TArgs extends unknown[], TReturn>(
  name: string,
  fn: (...args: TArgs) => Promise<TReturn>
): (...args: TArgs) => Promise<TReturn> {
  if (isProduction()) return fn

  return async (...args) => {
    const start = performance.now()
    try {
      return await fn(...args)
    } finally {
      console.warn(`${LABEL} ${name}: ${(performance.now() - start).toFixed(2)}ms`)
    }
  }
}
